import React, { useMemo, useEffect } from "react";
import PropTypes from "prop-types";

import {
  registerAppToastImplementation,
  showAppErrorToast,
  showAppErrorToasts,
} from "./appErrorBridge";
import { showSpectrumErrorToast } from "./showSpectrumErrorToast";

const noop = () => {};

/**
 * Registers the default Spectrum toast implementation so imperative helpers share one path.
 * Optional wrapper may be added later for logging/analytics.
 */
export function AppErrorsProvider({ children, onToast }) {
  const impl = useMemo(() => {
    return (message, options) => {
      const result = showSpectrumErrorToast(message, options);
      if (onToast) onToast(message, options);
      return result;
    };
  }, [onToast]);

  useEffect(() => {
    registerAppToastImplementation(impl);
    return () => registerAppToastImplementation(showSpectrumErrorToast);
  }, [impl]);

  return children;
}

AppErrorsProvider.propTypes = {
  children: PropTypes.node.isRequired,
  onToast: PropTypes.func,
};

AppErrorsProvider.defaultProps = {
  onToast: noop,
};

/** Hook preferred inside function components for toast notifications (scenario 2). */
export function useAppErrorToast() {
  return useMemo(
    () => ({
      toast: (message, options) => showAppErrorToast(message, options),
      toastMany: (messages, options) => showAppErrorToasts(messages, options),
    }),
    [],
  );
}
